import * as PIXI from 'pixi.js';

export default () => PIXI.utils.uid();
